import { imageAdapter } from '@/adapters/constructor/utils/image';

export default ({ data }) => {
  return {
    image: imageAdapter(data.banner, data.banner_mobile),
  };
};
